import * as Redux from 'redux';

import columnsReducer from './columnsReducer.model';
import fileReducer from './fileReducer.model';
import navigationReducer from './navigationReducer.model';
import searchResultsReducer from './searchResultsReducer.model';
import * as WorksheetsReducer from './worksheetsReducer.model';

const uploadReducer = Redux.combineReducers({
  columns: columnsReducer,
  file: fileReducer,
  navigation: navigationReducer,
  searchResults: searchResultsReducer,
  worksheets: WorksheetsReducer.worksheetsReducer
});

export const uploadRootReducer = (state, action) => {
  if (action.type === 'RESET_STATE') {
    state = undefined; // This will cause uploadReducers to re-init everything
  }

  return uploadReducer(state, action);
};
